import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/Layout';
import ProtectedRoute from '../components/ProtectedRoute';
import AdminGuard from '../components/AdminGuard';
import AuthRoutes from './AuthRoutes';
import {
  AdminDashboard,
  AdminOrders,
  OrderDetail,
  ManageUsers,
  ManageCompanies,
  UnderConstruction,
  AuditLogs,
  AdminDeliveries,
  AdminTransfers,
  AdminPayouts,
  FinancialLedger,
  InventoryLedger,
  AdminEmail,
  AdminSettings,
  // Shared portal pages that admin also needs
  Products,
  ProductInventory,
  CreateProduct,
  EditProduct,
  AdjustInventory,
  AdjustReview,
  DarkstoreBrand,
  DarkstoreListings,
  AdminDarkstore,
  Analytics,
  History,
  Transactions,
} from './lazyPages';

export default function AdminApp({ isAuthenticated }: { isAuthenticated: boolean }) {
  return (
    <Routes>
      {AuthRoutes({ isAuthenticated })}

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AdminGuard>
              <Layout />
            </AdminGuard>
          </ProtectedRoute>
        }
      >
        {/* Admin-specific routes */}
        <Route path="admin" element={<AdminDashboard />} />
        <Route path="admin/orders" element={<AdminOrders />} />
        <Route path="admin/orders/:orderNumber" element={<OrderDetail />} />
        <Route path="admin/users" element={<ManageUsers />} />
        <Route path="admin/audit" element={<AuditLogs />} />
        <Route path="admin/companies" element={<ManageCompanies />} />
        <Route path="admin/companies/:id" element={<UnderConstruction title="Company Details" description="Company detail view will be available soon." />} />
        <Route path="admin/deliveries" element={<AdminDeliveries />} />
        <Route path="admin/transfers" element={<AdminTransfers />} />
        <Route path="admin/payouts" element={<AdminPayouts />} />
        <Route path="admin/financial-ledger" element={<FinancialLedger />} />
        <Route path="admin/inventory-ledger" element={<InventoryLedger />} />
        <Route path="admin/email" element={<AdminEmail />} />

        {/* Shared portal routes — all prefixed under /admin/* to stay in admin mode */}
        <Route path="admin/products" element={<Products />} />
        <Route path="admin/products/inventory" element={<ProductInventory />} />
        <Route path="admin/products/create" element={<CreateProduct />} />
        <Route path="admin/products/:sku/edit" element={<EditProduct />} />
        <Route path="admin/products/:sku" element={<Products />} />
        <Route path="admin/inventory" element={<Navigate to="/admin/products/inventory" replace />} />
        <Route path="admin/inventory/adjust" element={<AdjustInventory />} />
        <Route path="admin/inventory/adjust/review" element={<AdjustReview />} />
        <Route path="admin/darkstore" element={<AdminDarkstore />} />
        <Route path="admin/darkstore/brand/:companyId" element={<DarkstoreBrand />} />
        <Route path="admin/darkstore/listings" element={<DarkstoreListings />} />
        <Route path="admin/transactions" element={<Transactions />} />
        <Route path="admin/history" element={<History />} />
        <Route path="admin/analytics" element={<Analytics />} />
        <Route path="admin/settings" element={<AdminSettings />} />

        {/* Default: /admin */}
        <Route index element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}
